import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { useLanguage } from "../i18n/LanguageContext";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  const { t } = useLanguage();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>{t("footer.developed")}</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>{t("footer.copyright").replace("{year}", year)}</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/Breinersmartinez"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>

          

            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/breiner-saul-martínez-muñoz-a48986323"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>

           

          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
